module.exports = __webpack_public_path__ + "img/instagram.303d877.svg";